import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/_services/app.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit {

  addGroupList: any;
  CategoryDropList: any;
  subCategoryList: any;
  allFileFilter: any = {
    group: 0,
    category: 0,
    subCategory: 0
  };
  fileData: any = {};

  constructor(
    private service: AppService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.groupList();
  }

  groupList() {
    this.service.postService({}, 'Master/GroupDropDownList').subscribe(response => {
      this.addGroupList = response.body;
      console.log(this.groupList);
    })
  }
  groupDropDown(id) {
    if (id == undefined) {
      id = 0;
      this.allFileFilter = {
        group: 0,
        category: 0,
        subCategory: 0
      };
    }
    this.spinner.show();
    this.service.postService({}, 'Master/categoryDropDownList?groupid=' + id).subscribe(response => {
      this.spinner.hide();
      this.CategoryDropList = response.body;
    })
  }
  CategoryDropDown(id) {
    if (id == undefined) {
      id = 0;
      this.allFileFilter = {
        group: this.allFileFilter.group,
        category: 0,
        subCategory: 0
      };
    }
    this.spinner.show();
    this.service.postService({}, 'Master/SubCategoryDropDownList?categoryId=' + id).subscribe(response => {
      this.spinner.hide();
      this.subCategoryList = response.body
    })
  }
  tableLoad() {
    if (this.allFileFilter.group == 0) {
      this.fileData.groupId = 0;
    } else {
      this.fileData.groupId = this.allFileFilter.group.groupId;
    }
    if (this.allFileFilter.category == 0) {
      this.fileData.categoryId = 0;
    } else {
      this.fileData.categoryId = this.allFileFilter.category.categoryId;
    }
    if (this.allFileFilter.subCategory == 0) {
      this.fileData.subCategoryId = 0;
    } else {
      this.fileData.subCategoryId = this.allFileFilter.subCategory.subCategoryId;
    }
    $('#table1').DataTable().ajax.reload();
  }
  clearFilter() {
    this.allFileFilter = {
      group: 0,
      category: 0,
      subCategory: 0
    };
    this.fileData.groupId = 0;
    this.fileData.categoryId = 0;
    this.fileData.subCategoryId = 0;
    $('#table1').DataTable().ajax.reload();
  }

}
